(function ($) {
  'use strict';

  /**
   * @param id
   * @constructor
   */
  this.WLCCountdown = function (id) {
    this.$countdown = $('#' + id);

    if (this.$countdown.length < 1) {
      this.$countdown = null;
      console.log('WLCCountdown: the element does not exist');
      return;
    }

    this.triggersActive = null;

    this.interval = null;

    this.countdownTo = null;

    // Initialize the value holders
    this.$years = null;
    this.$months = null;
    this.$days = null;
    this.$hours = null;
    this.$minutes = null;
    this.$seconds = null;

    var t = this;

    $.each(
      ['years', 'months', 'days', 'hours', 'minutes', 'seconds'],
      function (index, el) {
        t['$' + el] = t.$countdown.find('.' + el);
        if (t['$' + el].length < 1) {
          t['$' + el] = null;
        }
      }
    );
  };

  this.WLCCountdown.prototype.start = function (
    year,
    month,
    day,
    hour,
    minute,
    second
  ) {
    if (!this.$countdown) {
      console.log('WLCCountdown.start(): Not initialized properly');
    }

    second = second ? second : 0;
    minute = minute ? minute : 0;
    hour = hour ? hour : 0;
    day = day ? day : 1;
    month = month ? month : 1;
    year = year ? year : 2000;

    this.countdownTo = new Date(
      Date.UTC(year, month, day, hour, minute, second)
    );

    if (this.update()) {
      this.triggersActive = true;
      this.resume();
    }
  };

  this.WLCCountdown.prototype.leadingZeros = true;

  /**
   * Whether or not should we check the remainign time after starting the countdown and trigger the finish
   * event on the first iteration
   *
   * @type {boolean}
   */
  this.WLCCountdown.prototype.alwaysTriggerFinish = false;

  this.WLCCountdown.prototype.resume = function () {
    if (!this.$countdown) {
      console.log('WLCCountdown.resume(): Not initialized properly');
    }
    this.interval = setInterval(this.update.bind(this), 1000);
    this.$countdown.trigger('WLC:Countdown:started');
  };

  this.WLCCountdown.prototype.pause = function () {
    if (this.interval) {
      clearInterval(this.interval);
      this.$countdown.trigger('WLC:Countdown:paused');
    }
  };

  /**
   * TODO: Implement return values for years and months
   */
  this.WLCCountdown.prototype.update = function () {
    if (!this.$countdown) {
      console.log('WLCCountdown.update(): Not initialized properly');
    }
    var time = this.getRemainingTime();

    if (false && this.$years) {
      // Not implemented
      this.$years.html(this.formatNumber(time.years));
    }
    if (false && this.$months) {
      // Not implemented
      this.$months.html(this.formatNumber(time.months));
    }
    if (this.$days) {
      this.$days.html(this.formatNumber(time.days));
    }
    if (this.$hours) {
      this.$hours.html(this.formatNumber(time.hours));
    }
    if (this.$minutes) {
      this.$minutes.html(this.formatNumber(time.minutes));
    }
    if (this.$seconds) {
      this.$seconds.html(this.formatNumber(time.seconds));
    }

    if (time.total <= 0) {
      this.pause();
      if (this.alwaysTriggerFinish || this.triggersActive) {
        this.$countdown.trigger('WLC:Countdown:finished');
      }
      return false;
    }
    return true;
  };

  /**
   * TODO: Implement counting of months and years based on the current month/leap year
   *
   * @returns {{total: number, days: number, hours: number, minutes: number, seconds: number}}
   */
  this.WLCCountdown.prototype.getRemainingTime = function () {
    var t = this.countdownTo - new Date();
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      total: t < 0 ? 0 : t,
      days: days < 0 ? 0 : days,
      hours: hours < 0 ? 0 : hours,
      minutes: minutes < 0 ? 0 : minutes,
      seconds: seconds < 0 ? 0 : seconds,
    };
  };

  this.WLCCountdown.prototype.formatNumber = function (number) {
    if (this.leadingZeros && number < 10) {
      return '0' + number;
    }
    return number;
  };
}).bind(window)(jQuery);
